export const phaseIds = ['alert', 'investigate', 'simulate', 'approve', 'contain', 'report'] as const;
export type PhaseId = (typeof phaseIds)[number];

export type WebMcpStatus = 'checking' | 'registered' | 'unavailable' | 'error';
export type AssetStatus = 'critical' | 'warning' | 'safe' | 'neutral';
export type PlanId = 'full_shutdown' | 'targeted_isolation';

export interface Asset {
  id: string;
  name: string;
  kind: 'endpoint' | 'identity' | 'server' | 'care-service';
  status: AssetStatus;
  summary: string;
  evidenceRefs: string[];
}

export interface SecurityEvent {
  id: string;
  time: string;
  source: string;
  assetId: string;
  severity: 'info' | 'medium' | 'high' | 'critical';
  message: string;
  trust: 'scenario-evidence' | 'untrusted-log-content';
}

export interface SimulationResult {
  planId: PlanId;
  label: string;
  spreadRisk: number;
  careOnline: number;
  downtimeMinutes: number;
  actions: string[];
  verdict: string;
  recommended: boolean;
}

export interface LedgerEntry {
  sequence: number;
  time: string;
  actor: 'agent' | 'human' | 'rehearsal-engine';
  action: string;
  detail: string;
  evidenceRefs: string[];
  previousIntegrity: string;
  integrity: string;
}

export interface AfterActionReport {
  id: string;
  title: string;
  generatedAt: string;
  markdown: string;
  citations: Array<{ id: string; label: string }>;
}

export interface ScenarioState {
  phase: PhaseId;
  reachedPhase: number;
  webMcpStatus: WebMcpStatus;
  webMcpDetail: string;
  invokedTools: string[];
  inspectedAssetIds: string[];
  visibleEvents: SecurityEvent[];
  pathTraced: boolean;
  simulations: SimulationResult[];
  stagedPlanId: PlanId | null;
  approvalDrawerOpen: boolean;
  humanApproved: boolean;
  contained: boolean;
  report: AfterActionReport | null;
  ledger: LedgerEntry[];
}
